// extracted by mini-css-extract-plugin
export default {"features":"Features_features__sm9ba"};